// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9e39ac75","455":"8cc6b204","977":"278b431b"}[chunkId] + ".chunk.js";
};